module.exports = __webpack_public_path__ + "img/icon_changespeed_color.71d20c79.svg";